import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';

export const createSubAccount = createAsyncThunk(
    'subaccount/createSubAccount',
    async ({ username, password, phone, company, name }, thunkAPI) => {
        try {
            //console.log("In API thunk create subuser", username, password);
            const reqData = { username, password, phone_number: phone, company_name: company, name };
            const apiData = await apiClient.post('/subuser_create', reqData);
            if (apiData.data.error || apiData.data.result === 'error') {
                const errorCode = apiData.data.error || 'unknown';
                let message = 'Unable to create sub account. Please try again.';
                if (errorCode === 'userExists') {
                    message = 'Username or phone number already exists. Try a different one.';
                } else if (errorCode === 'Server Error') {
                    message = 'Server error while creating the sub account.';
                } else if (typeof errorCode === 'string') {
                    message = errorCode;
                }
                return thunkAPI.rejectWithValue({
                    code: errorCode,
                    message,
                    details: apiData.data.user || null,
                });
            }
            return { result: apiData.data.result, newsubaccount: apiData.data.user };
        } catch (error) {
            const responseError = error?.response?.data?.error;
            const fallbackMessage =
                (typeof responseError === 'string' && responseError) ||
                error?.message ||
                'Request failed.';
            return thunkAPI.rejectWithValue({
                code: 'requestFailed',
                message: fallbackMessage,
            });
        }
    }
);

export const getSubAccounts = createAsyncThunk(
    'subaccount/getSubAccounts',
    async (_, thunkAPI) => {
        try {
            //console.log("IN API Thunk getSubusers");
            const apiData = await apiClient.get('/subusers_get');
            if (apiData.data.error) {
                //console.log("SU list API error", apiData.data.error);
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                //console.log("Got SUbuser list", apiData.data.subusers);
                return { result: apiData.data.result, subaccounts: apiData.data.subusers };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }

    }
);

export const searchSubAccounts = createAsyncThunk(
    'subaccount/searchSubAccounts',
    async ({ query }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/subuser_search', { query });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result, subaccounts: apiData.data.subusers };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getSubAccountDetails = createAsyncThunk(
    'subaccount/getSubAccountDetails',
    async ({ subuser_id }, thunkAPI) => {
        try {
            //console.log("SUB user details required for", subuser_id);
            const apiData = await apiClient.post('/subuser_details_get', { subuser_id });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result, subaccount: apiData.data.subuser };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getAssetSensorList = createAsyncThunk(
    'subaccount/getAssetSensorList',
    async ({ assetId }, thunkAPI) => {
        try {
            //console.log("SUB user details required for", assetId);
            const apiData = await apiClient.post('/parent_user_imei_sensors_get', { imei: assetId });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result, sensors: apiData.data.sensors };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const parentAllSensorList = createAsyncThunk(
    'subaccount/parentAllSensorList',
    async (_, thunkAPI) => {
        try {
            //console.log("All Sensor of parent required");
            const apiData = await apiClient.post('/parent_user_all_imei_sensors_get', { imei: null });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result, sensors: apiData.data.sensors };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const parentSelectedSensorList = createAsyncThunk(
    'subaccount/parentSelectedSensorList',
    async ({ imeis }, thunkAPI) => {
        try {
            //console.log("Selected Sensor of parent required", imeis);
            const apiData = await apiClient.post('/parent_user_selected_imeis_sensors_get', { imeis });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result, sensors: apiData.data.sensors };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const createShare = createAsyncThunk(
    'subaccount/createShare',
    async ({ subuser_id, assetIds, sensorNames, access_upto }, thunkAPI) => {
        try {
            //console.log("CreateShare", subuser_id, assetIds, sensorNames, access_upto);
            const apiData = await apiClient.post('subuser_imei_mapping_create', { subuser_id, imeis: assetIds, sensorNames, access_upto });
            //console.log("resp createshare", apiData.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteShare = createAsyncThunk(
    'subaccount/deleteShare',
    async ({ subuser_id, assetIds }, thunkAPI) => {
        try {
            //console.log("Delete Share", subuser_id, assetIds);
            const apiData = await apiClient.post('subuser_imei_mapping_delete', { subuser_id, imeis: assetIds });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createZoneShare = createAsyncThunk(
    'subaccount/createZoneShare',
    async ({ subuser_id, zoneids }, thunkAPI) => {
        try {
            //console.log("CreateShare", subuser_id, zoneids);
            const apiData = await apiClient.post('subuser_zone_mapping_create', { subuser_id, zoneids });
            //console.log("resp createshare", apiData.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteZoneShare = createAsyncThunk(
    'subaccount/deleteZoneShare',
    async ({ subuser_id, zoneids }, thunkAPI) => {
        try {
            //console.log("Delete Share", subuser_id, zoneids);
            const apiData = await apiClient.post('subuser_zone_mapping_delete', { subuser_id, zoneids });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createMarkerShare = createAsyncThunk(
    'subaccount/createMarkerShare',
    async ({ subuser_id, markerids }, thunkAPI) => {
        try {
            //console.log("CreateShare", subuser_id, markerids);
            const apiData = await apiClient.post('subuser_marker_mapping_create', { subuser_id, markerids });
            //console.log("resp createshare", apiData.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteMarkerShare = createAsyncThunk(
    'subaccount/deleteMarkerShare',
    async ({ subuser_id, markerids }, thunkAPI) => {
        try {
            //console.log("Delete Share", subuser_id, markerids);
            const apiData = await apiClient.post('subuser_marker_mapping_delete', { subuser_id, markerids });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const toggleAccountActivation = createAsyncThunk(
    'subaccount/toggleAccountActivation',
    async ({ subuser_id, active }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('subuser_activation', { subuser_id, active });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteSubAccount = createAsyncThunk(
    'subaccount/deleteSubAccount',
    async ({ subuser_id }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('subuser_delete', { subuser_id });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createReportShare = createAsyncThunk(
    'subaccount/createReportShare',
    async ({ subuser_id, createReports }, thunkAPI) => {
        try {
            //console.log("CreateShare", subuser_id, createReports);
            const apiDataCreate = await apiClient.post('subuser_report_mapping_create', { subuser_id, reports: createReports });
            //console.log("resp createshare", apiDataCreate.data);
            if (apiDataCreate.data.error) {
                return thunkAPI.rejectWithValue(apiDataCreate.data.error);
            } else {
                return { result: apiDataCreate.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteReportShare = createAsyncThunk(
    'subaccount/deleteReportShare',
    async ({ subuser_id, reports }, thunkAPI) => {
        try {
            //console.log("Delete Share", subuser_id, reports);
            const normalizedReports = (reports || []).map((r) =>
                typeof r === 'string' ? { name: r } : r
            );
            const apiData = await apiClient.post('subuser_report_mapping_delete', { subuser_id, reports: normalizedReports });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const subaccountChangePassword = createAsyncThunk(
    'subaccount/subaccountChangePassword',
    async ({ subuser_id, password, confirmPassword }, thunkAPI) => {
        try {
            //console.log("chng pass", subuser_id, password, confirmPassword);
            const apiData = await apiClient.post('subuser_change_password', { subuser_id, password, confirmPassword });
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { result: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
